import React, { useEffect, useState } from "react";
import { Grid, makeStyles } from "@material-ui/core";
import { TicketItemDataFragment, TodoStatus, useGetTodoQuery } from "@graphql";
import { Spinner, Topbar } from "@components";
import { ErrorBoundary } from "@components/error-boundary";
import { ThemeType } from "@theme";
import { useLocale, useStore } from "@hooks";
import { Tabs } from "@components/Tabs";
import TicketEventLog from "@containers/EventLog/TicketEventLog/TicketEventLog";
import TicketEventLogStore from "@containers/EventLog/TicketEventLog/TicketEventLogStore";
import TicketsSideMenu from "./TicketsSidemenu/TicketsSideMenu";
import { TicketProfileCard } from "@tickets/TicketProfile/TicketProfileCard";

type Props = { id: string };

function TicketProfile(props: Props): React.ReactElement<Props> {
  const { id } = props;
  const ticketEventLogStore = useStore<TicketEventLogStore>(
    () => new TicketEventLogStore(id)
  );
  const [ticket, setTicket] = useState<TicketItemDataFragment>(null);
  const [editMode] = useState<boolean>(false);
  const { locale } = useLocale();

  const { loading, data, error } = useGetTodoQuery({
    variables: { id },
    fetchPolicy: "network-only"
  });

  useEffect(() => {
    if (data?.todo) {
      setTicket(data.todo);
    }
  }, [data]);

  const styles = useStyles({});

  if (loading) {
    return <Spinner fullHeight={true} />;
  }

  if (error) {
    throw error;
  }

  return (
    ticket && (
      <ErrorBoundary>
        <div style={{ padding: "8px 16px" }}>
          <Topbar />
        </div>

        <Grid container spacing={2} className={styles.root}>
          <Grid item xs={9}>
            <TicketProfileCard id={props.id} />

            <Tabs
              TabsProps={{
                indicatorColor: "primary"
              }}
              AppBarProps={{
                style: { borderTopRightRadius: 4, borderTopLeftRadius: 4, marginTop: 16 }
              }}
              tabs={[
                {
                  label: locale.ActionLog,
                  value: "events",
                  content: (
                    <TicketEventLog
                      disabledText={
                        ticket.Status === TodoStatus.Done
                          ? locale.tickets.commentFunctionSwitchedOffWhenTicketClosed
                          : null
                      }
                      commentBoxDisabled={
                        editMode || ticket.ViewMode || ticket.Status === TodoStatus.Done
                      }
                      store={ticketEventLogStore}
                    />
                  )
                }
              ]}
            />
          </Grid>

          <Grid item xs={3}>
            <TicketsSideMenu ticket={ticket} />
          </Grid>
        </Grid>
      </ErrorBoundary>
    )
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    padding: theme.spacing(2),
    marginTop: -16
  }
}));

export default TicketProfile;
